import React, { useState } from 'react';

import './TextArea.scss';
import {TextAreaLog} from "../../services/interactions/elements/textarea";


function TextArea({placeholder, label, value, onChange, onBlur, disabled, required, error }) {
    const [isFocused, setIsFocused] = useState(false);
    const _onBlur = () => {
        setIsFocused(false);
        if (onBlur) {
            onBlur();
        }
    }
    const onFocus = () => {
        setIsFocused(true);
    }
    const _onChange = (e) => {
        onChange(e.target.value);
    }
    return (
        <div className={`InputComponent ${isFocused ? 'focused' : ''} ${(!!value || isFocused) ? 'dirty' : ''} ${error ? 'error' : ''}`}>
            {
                label ? 
                    <label>
                        {label}{required ? <span className="__req">*</span> : ''}
                    </label>
                : ''
            }
            <textarea
                value={value}
                onBlur={_onBlur}
                onFocus={onFocus}
                onChange={_onChange}
                disabled={disabled || false}
                placeholder={placeholder}
            ></textarea>
        </div>
    )
}

export default TextAreaLog(TextArea);
